// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__K1tTl","box":"WorkspacesBox_box__3MiAo","node":"WorkspacesBox_node__3JVZq"};